import React from "react";
import Img from "gatsby-image";

const CaptionedImage = ({ img, caption, link, alt }) => (
  <figure className="mb-4">
    {img && <Img fluid={img.childImageSharp.fluid} alt={alt} />}
    <figcaption className="text-xs bg-neutral-light text-neutral-dark py-1 text-center">
      {caption.html && (
        <div dangerouslySetInnerHTML={{__html: caption.html}} />
      ) || (link && (
        <a href={link} target="_blank" className="italic">
          {caption.text}
        </a>
      )) || caption.text}
    </figcaption>
  </figure>
);


export default CaptionedImage;
